__turbopack_context__.v({
  "gradientOverlay": "overlay-module__Czj1hq__gradientOverlay",
});
